// @flow
export const SET_ALL_TASKS_COUNT = 'GET_ALL_TASKS_COUNT';
export const SET_MY_TASKS_COUNT = 'GET_MY_TASKS_COUNT';
export const SET_ALL_COMMUNICATION_TASKS_COUNT = 'GET_ALL_COMMUNICATION_TASKS_COUNT';
export const SET_MY_COMMUNICATION_TASKS_COUNT = 'GET_MY_COMMUNICATION_TASKS_COUNT';
export const MOUNT_POINT = 'FREE_TASKS';
